import { render } from "./FaceSmile.vue?vue&type=template&id=1d46740d"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/FaceSmile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d46740d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d46740d', __exports__)) {
    api.reload('1d46740d', __exports__)
  }
  
  module.hot.accept("./FaceSmile.vue?vue&type=template&id=1d46740d", () => {
    api.rerender('1d46740d', render)
  })

}


export default __exports__